import { useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';

import Frame from '../layout/Frame';
import { Button, Input, Popup } from '../components';
import { AppRoute, ButtonType, InputType } from '../types/enums';
import { isPasswordAcceptable } from '../utils/common';
import { resetPassword } from '../requests/requests';
import useErrorHandler from '../hooks/useErrorHandler';

const ResetPassword = () => {
  const { passwordResetToken } = useParams<{ passwordResetToken: string }>();
  const errorHandler = useErrorHandler();
  const [password, setPassword] = useState('');
  const [inputError, setInputError] = useState('');
  const [isResetSuccessful, setIsResetSuccessful] = useState(false);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setInputError('');

    if (!isPasswordAcceptable(password)) {
      setInputError('Password must contain at least 8 characters');
      return;
    }

    if (passwordResetToken) {
      resetPassword(password, passwordResetToken)
        .then(() => {
          setIsResetSuccessful(true);
        })
        .catch(errorHandler);
    }
  };

  return (
    <Frame>
      <Popup show title="Update password" permanent>
        {isResetSuccessful ? (
          <div>
            <p>
              Password updated successfully. Please{' '}
              <NavLink className="color-orange" to={AppRoute.LOGIN}>
                log in with your new password
              </NavLink>
            </p>
          </div>
        ) : (
          <div>
            <p>Please set your new password</p>
            <form onSubmit={onSubmit}>
              <Input
                id="password"
                label="New password:"
                value={password}
                setValue={setPassword}
                placeholder="********"
                error={inputError}
                type={InputType.PASSWORD}
              />
              <Button type={ButtonType.PRIMARY} fullWidth isSubmit>
                Update password
              </Button>
            </form>
          </div>
        )}
      </Popup>
    </Frame>
  );
};

export default ResetPassword;
